import { InvoiceDiscountType } from '../enums/invoiceDiscountType'

export const isAmountDiscountType = (discountType: InvoiceDiscountType): boolean =>
  discountType === InvoiceDiscountType.Amount
